import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MatDialog } from '@angular/material/dialog';
import { CameraServerService } from '../camera-server.service';
import { ToastrService } from 'ngx-toastr';
import { SpinnerService } from 'src/app/components/spinner-component/spinner.service';
import { ConfigService } from 'src/app/services/config.service';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { AppConstants } from 'src/app/shared/app-constants';
import { SelectionModel } from '@angular/cdk/collections';
import { ConfirmationDialogueComponent } from 'src/app/components/confirmation-dialogue/confirmation-dialogue.component';

export interface TableElement {
  id: number;
  potentialName: string;
  unitId: any;
  unitType: any;
  status: string;
}

@Component({
  selector: 'app-cancel-site-list',
  templateUrl: './cancel-site-list.component.html',
  styleUrls: ['./cancel-site-list.component.scss']
,
  standalone: false
})
export class CancelSiteListComponent implements OnInit {

  loading: boolean = false;
  displayedColumns: string[] = ['id', 'potentialName', 'unitId', 'unitType', 'status', 'action'];
  dataSource = new MatTableDataSource<TableElement>([]);
  selection = new SelectionModel<TableElement>(true, []);
  totalRecords: number = 0;
  pageSize: number = 10;
  pageNumber: number = 0;
  loggedInUser: string;

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  constructor(
    private router: Router,
    private ngbModalService: NgbModal,
    private camService: CameraServerService,
    private toasts: ToastrService,
    public spinner: SpinnerService,
    public dialog: MatDialog,
    public configService: ConfigService,
  ) { }

  ngOnInit(): void {
    let user = JSON.parse(localStorage.getItem('loggedInUser') || '{}');
    this.loggedInUser = user?.email;
    this.getCancelledSiteList();
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.pageNumber = this.paginator?.pageIndex;
    this.pageSize = this.paginator?.pageSize;
    this.sort?.active;
    this.dataSource.sort = this.sort;
    this.sort?.direction;
    this.sort?.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
  }

  /** Get All cancelled sites */
  getCancelledSiteList() {
    this.spinner.activate();
    this.loading = true;
    this.camService.getCancelSiteList().subscribe((response: any) => {
      if (response && response.success) {
        this.spinner.deactivate();
        this.loading = false;
        this.dataSource = new MatTableDataSource<any>(response?.data);
        this.dataSource.paginator = this.paginator;
        this.totalRecords = response?.data?.length || []?.length;
        this.dataSource.sort = this.sort;
      } else {
        this.spinner.deactivate();
        this.loading = false;
        this.toasts.error(response?.message || AppConstants.defaultErrorMessage);
      }
    }, err => {
      this.loading = false;
      this.spinner.deactivate();
      if (err && err.error && err.error.message && err.error.message.length > 0) {
        this.toasts.error(err.error.message, 'Error');
      } else {
        this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
      }
    });
  }

  /** Methods for pagination */
  changePaging(event: any) {
    this.pageNumber = event.pageIndex;
    this.pageSize = event.pageSize;
    this.getCancelledSiteList();
  }

  /** Remove cancelled Site */
  deleteCancelledSite(event: any, element: any) {
    let popupData = {
      title: "Delete Confirmation?",
      message: `Are you sure you want to delete this site - ${element?.potentialName} (${element?.vtigerPotentialId})`,
      cancelBtnText: "No",
      confirmBtnText: "Yes"
    }
    let dialog = this.ngbModalService.open(ConfirmationDialogueComponent);
    dialog.componentInstance._data = popupData;
    dialog.result.then(data => {
      if (data) { //this data return true if user click on Yes, and if No the return false
        this.spinner.activate();
        this.loading = true;
        this.camService.deleteCancelSite(element?.vtigerPotentialId, this.loggedInUser).subscribe((response: any) => {
          if (response && response.success) {
            this.spinner.deactivate();
            this.loading = false;
            this.toasts.success('Site deleted successfully.');
            this.getCancelledSiteList();
          } else {
            this.spinner.deactivate();
            this.loading = false;
            this.toasts.error(response?.messages[0] || AppConstants.defaultErrorMessage);
          }
        }, (err) => {
          this.spinner.deactivate();
          if (err && err.error && err.error.message && err.error.message.length > 0) {
            this.toasts.error(err.error.message, 'Error');
          } else {
            this.toasts.error(AppConstants.defaultErrorMessage, 'Error');
          }
        })
      }
    })
  }

}
